import { useMemo } from 'react'
import styleForLayer, { borderOnlyStyle } from '../styleForLayer'
import { Layer, SpaceChildrenItem } from '~/packages/general/variable/spaceTime.types'
import { formatExpressionValue } from '~/prix'
import { formatNumberAsCluster } from '~/components/map/formatNumberAsCluster'

interface useStylesProps {
  layers: Layer[]
  ranges?: {
    min: number
    max: number
    totalNumerator?: number
    totalDenominator?: number
    total?: number
  }[]
}

export function useStyles({ layers, ranges = [] }: useStylesProps) {
  const styles = useMemo(
    () =>
      layers.map((layer, index) =>
        styleForLayer(layer, {
          totalValue: ranges[index]?.total ?? 0,
          totalNumeratorValue: ranges[index]?.totalNumerator ?? 0,
          totalDenominatorValue: ranges[index]?.totalDenominator ?? 0,
          minValue: ranges[index]?.min ?? 0,
          maxValue: ranges[index]?.max ?? 0,
          fillOpacity: layers.length === 1 ? 0.7 : 0.5,
          strokeOpacity: layers.length === 1 ? 1 : 0.5,
        }),
      ),
    [layers, ranges],
  )

  const hexagonStyles = useMemo(
    () =>
      layers.map((layer, index) =>
        layer.space.childrenType === 'item' &&
        (layer.space as SpaceChildrenItem).childrenItemView === 'cluster'
          ? styleForLayer(layer, {
              totalValue: ranges[index]?.total ?? 0,
              totalNumeratorValue: ranges[index]?.totalNumerator ?? 0,
              totalDenominatorValue: ranges[index]?.totalDenominator ?? 0,
              minValue: ranges[index]?.min ?? 0,
              maxValue: ranges[index]?.max ?? 0,
              fillOpacity: layers.length === 1 ? 0.9 : 0.5,
              strokeOpacity: layers.length === 1 ? 1 : 0.5,
            })
          : borderOnlyStyle,
      ),
    [layers, ranges],
  )

  const valueFormatters = useMemo(
    () =>
      layers.map(layer => {
        if (layer.space.childrenType === 'item' && layer.space.childrenItemView === 'cluster') {
          return formatNumberAsCluster
        }
        return (value: number) => formatExpressionValue(value, layer.variable)
      }),
    [layers],
  )

  return { hexagonStyles, styles, valueFormatters }
}
